/*
 * md-google-price.js — v23 (Korbmarge-Rueckfall ueber die eigene Section mdzo-kx statt Supabase cart-kx)
 * v22 (auch die Preis-Klassen nur bei echter Aenderung schreiben)
 * v21 (Klassenliste von <html> nur bei echter Aenderung schreiben)
 * v20 (Marge-Write gesammelt UND mitfahrend; v18: Tokens nur mit Korb- oder Seitenbezug)
 *
 * NEU v23 (2026-09-21): Der letzte externe Request aus dem Warenkorb entfaellt. Fehlt der Karte md_kx_map eine
 * Position, holt das Skript sections/mdzo-kx.liquid per Section Rendering vom EIGENEN Shop (kx/kn der
 * Korbpositionen aus denselben Metafeldern) und rechnet mit kxLokal(positionen, true) neu — dort zaehlt eine
 * Variante ohne Werte 0 und ein fehlender/unplausibler Live-Preis faellt auf die Tabellenwerte zurueck, wie es
 * der Endpunkt tat. Gemessen vorher: 9 Endpunkt-Aufrufe in 24 h. Scheitert der Abruf, wird nichts geschrieben.
 *
 * NEU v20 (2026-09-19): Der gesammelte Marge-Write meldet sich beim gemeinsamen Schreiber als
 * Nachlieferer an. v19 allein hatte beim Hinzufuegen einen Write MEHR erzeugt, weil custom.js
 * refcons sofort schreibt und die Marge 1,5 s wartete. Jetzt faehrt sie auf dem fremden Write mit.
 *
 * NEU v19 (2026-09-19): Der Korb-Write fuer _kx/_kxg wird gesammelt (KX_SAMMEL_MS), statt nach jeder
 * Mengenaenderung sofort zu laufen. Gemessen: drei Klicks im Abstand von 700 ms erzeugten zwei
 * Attribut-Writes. Fuer die Kasse aendert sich nichts, weil kxZuletzt sofort gesetzt und im
 * Absende-Moment ins Formular geschrieben wird — beide Kassen-Knoepfe (Warenkorbseite und Drawer per
 * form="cart-drawer-form") loesen dieses submit aus, am 19.09. im DOM geprueft.
 *
 * NEU v18 (2026-09-19): _gad_tokens traegt nur noch Tokens, deren Variante im Korb liegt oder gerade auf einer Produktseite
 * betrachtet wird. v17 schrieb ALLE gueltigen Tokens des Browsers hinein; dadurch trugen Bestellungen Tokens von nie gekauften
 * Artikeln (85127426, 85127432) und sahen nach Ausfall aus, obwohl die Function richtig entschieden hatte. Der Sofort-Preis im
 * Drawer bleibt erhalten, weil die betrachtete Variante weiter aufgenommen wird.
 *
 * NEU v17 (2026-09-19): Im Function-Modus zeigte der Drawer nach dem Add den alten Preis — _gad_tokens kam erst ~3 s nach dem Add in
 * den Korb, der Drawer war da schon gerendert. Jetzt traegt das Attribut alle gueltigen Tokens des Browsers (Korb-Varianten zuerst)
 * und wird schon bei der Landung geschrieben; aendert es sich bei gefuelltem Korb, werden Drawer/Warenkorbzeilen neu gerendert.
 *
 * NEU v16 (2026-09-19): Schalter window.mdzoGadModus. 'code' (Standard) = bisheriger Weg (gad-validate, Rabattcode, Cookie).
 * 'function' = der Google-Preis kommt von der Shopify Function gad-preis (automatische Rabatte GAD-Google-Preis-0..2): dieses Skript
 * schreibt nur noch die Tokens der Korb-Varianten ins Korb-Attribut _gad_tokens (JSON-Array, max. 8, hoechstens 48 h alt) — kein
 * Aufruf von gad-validate, kein Code, kein Discount-Cookie, keine Sammel-Code-Box; ein alter GAD-Code am Korb wird entfernt.
 * Das Attribut reist zusaetzlich mit dem Kassen-Formular (wie _kx seit v12). Anzeige auf der PDP und _kx/_kxg unveraendert.
 *
 * NEU v15 (2026-09-17): (1) postEinloesung schreibt den erhaltenen Code auch in die
 * Store-Eintraege der gesendeten Tokens — bisher setzte nur codeVorabAnlegen rec.code,
 * und ohne rec.code fiel _kxg nach dem Token-Ablauf trotz v14 auf 0, wenn der Code erst
 * im Warenkorb-Schritt entstand. (2) md_gad_store verwirft beim Laden Eintraege, die
 * aelter als die Code-Laufzeit (48 h) sind; vorher wuchs der Store je pv2-Landung
 * dauerhaft um einen Eintrag samt JWT. CODE_TTL_MS steht jetzt bei STORE_KEY.
 *
 * NEU v14 (2026-09-17): Der Nachlass fuer das Attribut _kxg haengt nicht mehr am
 * exp-Claim des pv2-Tokens (~60 Min), sondern an der Gueltigkeit des angelegten
 * Rabattcodes (48 h, shops.gad_code_gueltig_stunden). Befund: 5 von 68
 * GAD-Bestellungen seit 14.09. trugen _kxg = 0 trotz gewaehrtem Rabatt — alle mit
 * mehr als 60 Min zwischen Code-Erstellung und Bestellung (49 Min groesster Abstand
 * mit korrektem Wert, 64 Min kleinster mit 0). Neue Pruefung gadPreisGueltig() nur
 * fuer die Wertberechnung; eintragEinloesbar bleibt fuer das Anlegen neuer Codes
 * und die Token-Liste an gad-validate unveraendert. Keine zusaetzlichen Requests.
 *
 * NEU v13 (2026-09-14): _kx/_kxg-Attribute und der GAD-Rabattcode gehen ueber
 * window.mdzoCartWrite (mdzo-cart-writer.js): gesammelt und serialisiert, ein
 * update.js statt zwei parallele; wartet auf fremde Cart-Writes (Theme). Ohne
 * Schreiber (Fallback) direkter fetch wie bisher.
 *
 * NEU v12 (2026-09-14): _kx/_kxg reisen zusaetzlich mit dem Kassen-Formular. Jede
 * Entscheidung ueber die Werte (Memo, lokale Rechnung, Endpunkt) wird gemerkt
 * (kxZuletzt); ein submit-Capture auf dem Formular mit action /cart setzt
 * attributes[_kx]/[_kxg] im Absende-Moment — synchron im selben Request wie der
 * Checkout-Start. Beleg 07.-14.09.: Bestellungen mit refcons, aber ohne _kx =
 * asynchroner Write (300 ms + Leerlauf) kam nach dem Kasse-Klick. Nie leere
 * Felder; asynchrone Writes bleiben (Wallet-Buttons umgehen das Formular).
 * (v11, 05.09.2026: Event-Cart statt GET /cart.js — nur im Rumpf vermerkt.)
 *
 * NEU v10 (2026-09-02): Die Korb-Marge wird im Browser gerechnet, wenn
 * fuer ALLE Positionen die Metafeld-Werte bekannt sind: mdzo.kx (Marge
 * netto) und mdzo.kn (Netto) je Variante, vom dataLayer-Snippet (v3) auf
 * PDP und Warenkorbseite als window.mdzoKx/mdzoKn gerendert und hier 24 h
 * in localStorage (md_kx_map) gesammelt. Rechenweg wie cart-kx v4:
 * EK = kn - kx, Live-Netto = Preis/(1+MWST), Marge = Live-Netto - EK,
 * Google-Nachlass netto gedeckelt auf die Marge. Der Endpunkt cart-kx
 * bleibt Fallback fuer Positionen ohne bekannte Werte (Quick-Add aus
 * Listen). _kx/_kxg-Attribute unveraendert (Offline-Conversions).
 * KEEP IN SYNC: MWST mit shops.mwst_pct und mdzo-datalayer.liquid.
 *
 * NEU v9 (2026-09-02):
 *   1. Endpunkt-Aufrufe als "einfache Requests" (Content-Type text/plain,
 *      kein Authorization-Header): der Browser spart das OPTIONS-Preflight,
 *      Supabase einen Kaltstart je Aufruf (Messung: jede Anfrage startete
 *      kalt). Endpunkte laufen mit verify_jwt=false; Autorisierung bleibt
 *      Origin-Check (cart-kx) bzw. Google-Signatur (gad-validate).
 *   2. Der GAD-Code wird schon beim LANDEN auf der PDP angelegt (Token aus
 *      der URL) und das Discount-Cookie sofort gesetzt — der Rabatt steht,
 *      bevor der Kunde klickt, auch bei "Direkt zur Kasse" (ueberspringt
 *      den Warenkorb). Der Warenkorb-Schritt bekommt denselben Code per
 *      Dedup in Millisekunden zurueck.
 *   3. /discount/<code> folgt dem Redirect nicht mehr (sparte sonst je
 *      Korb-Aenderung den Download der Startseite); Debounce 600 -> 300 ms.
 *
 * NEU v8 (2026-09-02): Befund — bei ~13 % der berechtigten Bestellungen
 * kam der GAD-Code im Checkout NICHT zur Anwendung (schneller bzw.
 * beschleunigter Checkout, bevor das Discount-Cookie stand): Kunde zahlte
 * den Regulaerpreis, die Marge war trotzdem um den Nachlass gekuerzt.
 *   1. Der Code wird zusaetzlich DIREKT am Warenkorb gesetzt
 *      (POST /cart/update.js {discount}, Shopify seit Mai 2025). Der Rabatt
 *      haengt damit am Cart selbst, nicht nur am Cookie — und ueberlebt
 *      Express-/Schnell-Checkouts. Fremde Codes des Kunden bleiben
 *      erhalten (nur GAD-Codes werden ersetzt/entfernt).
 *   2. Cart-Attribute getrennt: _kx = Korb-Marge netto OHNE Google-
 *      Nachlass, _kxg = Nachlass netto (Cents). Der Checkout-Pixel (v3)
 *      zieht _kxg nur ab, wenn im Checkout wirklich ein GAD-Code wirkt.
 *      Braucht cart-kx v3 (liefert kxOhneAbzugCents/gadNachlassCents;
 *      aeltere Antwort -> kxCents wie bisher, _kxg = 0).
 *   3. Jede Position meldet ihren Live-Preis (cart.js item.price) mit;
 *      cart-kx v4 rechnet die Marge bei Abweichung von der Nachttabelle
 *      neu (EK bleibt) — Preisaenderungen untertags kommen sofort an.
 *
 * NEU v7 (2026-08-31): Der cart-kx-Aufruf wird uebersprungen, wenn sich
 * am Korb-Zustand (Positionen, Mengen, Google-Preise) nichts geaendert
 * hat und das _kx-Attribut schon stimmt (localStorage-Memo, 10 Min. TTL —
 * passend zum Margen-Cache des Endpunkts). Fehlt nur das Attribut, wird
 * es aus dem Memo geschrieben, ohne den Endpunkt zu fragen.
 *
 * NEU v6 (2026-08-31): Bei jeder Warenkorb-Aenderung (im selben Debounce
 * wie die GAD-Einloesung) holt das Skript die NETTO-Korbmarge vom
 * cart-kx-Endpunkt (Quelle: naechtliche Margen-Tabelle in Supabase,
 * GAD-Nachlaesse eingerechnet) und schreibt sie als Cart-Attribut
 * "_kx" (Cents; Unterstrich = im Checkout unsichtbar). Der
 * Checkout-Pixel reicht das Attribut in den GTM-dataLayer (Kaufwert =
 * Marge, Fallback Netto-Umsatz). Aktualisiert wird nur bei Aenderung.
 *
 * NEU v5 (2026-08-31): Anzeige und Einloesung haben getrennte Fenster.
 * ANZEIGE bleibt 30 Min. (Google-Vorgabe); EINLOESBAR ist ein Token bis
 * zu seinem echten exp-Claim (~60 Min.). Und: Sind alle Tokens abgelaufen,
 * der Google-Artikel liegt aber noch im Korb, bleibt der verdiente Code
 * (48h) bestehen — aufgeraeumt wird nur, wenn die Artikel den Korb
 * verlassen haben. (Vorher deaktivierte jede Korb-Aktion nach 30 Min.
 * den Code, der Kunde verlor den zugesagten Rabatt.)
 * Degradation bewusst: Aendert sich der Korb, waehrend EIN Token von
 * mehreren abgelaufen ist, deckt der neue Code nur die noch einloesbaren
 * Varianten (der Server kann Abgelaufene nicht mehr validieren).
 *
 * NEU v4 (2026-08-31): Der Google-Preis gilt fuer JEDE Einheit, nicht nur
 * die erste. Bei genau einer Google-Variante legt der Server den Code als
 * Stueck-Rabatt an (appliesOnEachItem — Shopify multipliziert selbst, keine
 * Client-Angabe noetig); bei mehreren Varianten meldet das Skript die
 * Mengen aus /cart.js mit und der Server multipliziert (serverseitig
 * gedeckelt). Die sig enthaelt deshalb jetzt auch die Mengen.
 *
 * Google "automatische Rabatte" in Selbst-Integration:
 *   1. ANZEIGE: Liest das pv2-Token aus der Anzeigen-URL, merkt es je
 *      Variante 30 Minuten (localStorage) und schreibt den Google-Preis "p"
 *      SELBST in den Preisblock (frueher tat das die App). Badge,
 *      Streichpreis, Grundpreis- und Netto-Anpassung uebernimmt die
 *      bestehende Anzeige-Mechanik unveraendert.
 *   2. EINLOESUNG (v3, SAMMEL-CODE): Der Shopify-Checkout wendet
 *      automatisch nur EINEN Code an (Discount-Cookie); mehrere
 *      Einzelcodes stapeln nur manuell. Deshalb sendet das Skript bei
 *      jeder Warenkorb-Aenderung ALLE frischen Tokens der im Warenkorb
 *      liegenden Varianten an die Edge Function. Sie prueft jede
 *      ES256-Signatur, legt EINEN 48h-Code (GAD-...) ueber die SUMME der
 *      Nachlaesse an (gebunden an die berechtigten Varianten),
 *      deaktiviert den Vorgaenger-Code und der neue Code wird per
 *      /discount/<code> als Cookie gesetzt — vollautomatisch, egal wie
 *      viele Google-Artikel im Korb liegen.
 *
 * SICHERHEIT: Der Browser prueft die Signatur NICHT — er zeigt nur an.
 * Verbindlich wird der Preis erst durch die serverseitige Validierung.
 * Ein manipuliertes Token zeigt schlimmstenfalls kurz einen falschen
 * Preis an, erzeugt aber nie einen Rabattcode.
 *
 * KEEP IN SYNC: COOKIE_NAME / MARKERS mit snippets/md-volume-discount.liquid.
 * Marker-Konvention seit 30.08.2026: Praefix "GAD-", VERANKERT geprueft
 * (beginnt-mit, nie Teilstring — kurze Marker treffen sonst fremde Codes).
 */
(function () {
  'use strict';

  var BADGE_TEXT = 'Dein persönlicher Rabattpreis';
  var COOKIE_NAME = 'discount_code';
  // Praefix-verankerte Marker (indexOf === 0), siehe Kopfkommentar.
  var MARKERS = ['GAD-'];
  var URL_PARAM = 'pv2';
  var PRICE_SELECTOR = '.product-info__price .price, .price';
  var ORIG_ATTR = 'data-md-gp-original';
  // KEEP IN SYNC: layout/theme.liquid (Head-Schnipsel), assets/custom.css und
  // snippets/md-volume-discount.liquid.
  var HTML_CLASS = 'md-google-price';

  // --- GAD-Konfiguration --------------------------------------------------
  var GAD_ENDPOINT = 'https://dxgoxjkelehfrjxfhdwm.supabase.co/functions/v1/gad-validate';
  // v23: Korbmarge-Rueckfall — Section Rendering am eigenen Shop (sections/mdzo-kx.liquid), kein Supabase mehr.
  var KX_SECTION = 'mdzo-kx';
  var GAD_SHOP = 'mundizio';
  // v16: 'code' | 'function' (siehe Kopf). Alles ausser 'function' gilt als 'code'.
  var MODUS = window.mdzoGadModus === 'function' ? 'function' : 'code';
  var TOKENS_ATTRIBUT = '_gad_tokens';
  var TOKENS_MAX = 8; // KEEP IN SYNC: Cap in mdzo-gad/extensions/gad-preis (take(8))
  // v9: kein Auth-Header mehr (Endpunkte mit verify_jwt=false) — der
  // Aufruf bleibt ein "einfacher Request" ohne Preflight.
  // Google-Vorgabe: Rabattpreis mindestens 30 Minuten anzeigen.
  var ANZEIGE_FENSTER_MS = 30 * 60 * 1000;

  // ---- Helfer ------------------------------------------------------------
  function getCookie(name) {
    if (!name) return '';
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    return parts.length === 2 ? decodeURIComponent(parts.pop().split(';').shift()) : '';
  }

  function isGoogleSession() {
    var v = getCookie(COOKIE_NAME);
    if (v) {
      for (var i = 0; i < MARKERS.length; i++) {
        // verankert: Code muss mit dem Marker BEGINNEN
        if (MARKERS[i] && v.indexOf(MARKERS[i]) === 0) return true;
      }
    }
    // Auch ohne Cookie: aktives 30-Minuten-Fenster einer Variante zaehlt.
    return storeHatFrischenEintrag();
  }

  function urlHasParam(name) {
    if (!name) return false;
    try {
      return new URLSearchParams(window.location.search).has(name);
    } catch (e) {
      return ('' + window.location.search).indexOf(name + '=') !== -1;
    }
  }

  // "79,95 €" -> 7995, "1.234,56 €" -> 123456, "56.76" -> 5676
  function parseMoneyCents(str) {
    if (!str) return null;
    var s = ('' + str).replace(/[^0-9.,]/g, '');
    if (!s) return null;
    var dec = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    var intPart, fracPart;
    if (dec === -1) {
      intPart = s;
      fracPart = '';
    } else {
      intPart = s.slice(0, dec).replace(/[.,]/g, '');
      fracPart = s.slice(dec + 1).replace(/[.,]/g, '');
    }
    fracPart = (fracPart + '00').slice(0, 2);
    var cents = parseInt(intPart || '0', 10) * 100 + parseInt(fracPart || '0', 10);
    return isNaN(cents) ? null : cents;
  }

  // ---- Variant-Daten aus dem <variant-picker> JSON ----------------------
  var _vpData = null;
  function getVariantData() {
    if (_vpData !== null) return _vpData;
    _vpData = false;
    var el = document.querySelector('variant-picker script[type="application/json"]');
    if (el) {
      try {
        _vpData = JSON.parse(el.textContent) || false;
      } catch (e) {
        _vpData = false;
      }
    }
    return _vpData;
  }

  function getMetaVariants() {
    try {
      return (window.ShopifyAnalytics.meta.product.variants) || null;
    } catch (e) {
      return null;
    }
  }

  function deriveFmt(sample) {
    var fmt = { sym: '€', prefix: true, dec: ',', thou: '.' };
    if (!sample) return fmt;
    var sym = sample.replace(/[\d\s., ]/g, '');
    if (sym) {
      fmt.sym = sym;
      fmt.prefix = sample.replace(/\s| /g, '').indexOf(sym) === 0;
    }
    var m = sample.match(/(\d)([.,])(\d{2})(?!\d)/);
    if (m) { fmt.dec = m[2]; fmt.thou = m[2] === ',' ? '.' : ','; }
    return fmt;
  }

  function formatLikeSample(cents, sample) {
    var fmt = deriveFmt(sample);
    var neg = cents < 0;
    cents = Math.abs(Math.round(cents));
    var e = Math.floor(cents / 100);
    var c = ('0' + (cents % 100)).slice(-2);
    var es = ('' + e).replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thou);
    var num = es + fmt.dec + c;
    var s = fmt.prefix ? (fmt.sym + num) : (num + ' ' + fmt.sym);
    return (neg ? '-' : '') + s;
  }

  function getVariantPriceUnit(variantId) {
    var data = getVariantData();
    if (data && data.product && data.product.variants) {
      var vs = data.product.variants;
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(variantId)) {
          var v = vs[i];
          if (typeof v.price === 'number' && v.price > 0 &&
              typeof v.unit_price === 'number' && v.unit_price > 0) {
            return { price: v.price, unitPrice: v.unit_price, measurement: v.unit_price_measurement || null };
          }
          return null;
        }
      }
    }
    return null;
  }

  function getVariantShopPriceCents(variantId) {
    var quellen = [];
    var data = getVariantData();
    if (data && data.product && data.product.variants) quellen.push(data.product.variants);
    var mv = getMetaVariants();
    if (mv) quellen.push(mv);
    for (var q = 0; q < quellen.length; q++) {
      var vs = quellen[q];
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === String(variantId) &&
            typeof vs[i].price === 'number' && vs[i].price > 0) {
          return vs[i].price;
        }
      }
    }
    return null;
  }

  function displayCurrencyIsShopCurrency() {
    try {
      var c = window.Shopify && window.Shopify.currency;
      if (!c || c.rate == null) return true;
      return Math.abs(parseFloat(c.rate) - 1) < 0.0001;
    } catch (e) {
      return true;
    }
  }

  // ---- GAD-Token-Store (localStorage, je Variante) -----------------------
  // Eintrag: { pp: Cents|null, p: Cents|null, token: JWT, at: ms, code: str|null }
  var STORE_KEY = 'md_gad_store';
  // Code-Laufzeit; KEEP IN SYNC mit shops.gad_code_gueltig_stunden (48). Grenze fuer gadPreisGueltig (v14)
  // und fuer das Aufraeumen des Stores (v15).
  var CODE_TTL_MS = 48 * 60 * 60 * 1000;
  var _storeMem = null;

  function store() {
    if (_storeMem) return _storeMem;
    _storeMem = {};
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      if (raw) _storeMem = JSON.parse(raw) || {};
    } catch (e) { _storeMem = {}; }
    // v15: Eintraege aelter als die Code-Laufzeit sind fuer Anzeige, Token und Code wertlos -> weg.
    var jetzt = Date.now(), weg = false;
    for (var k in _storeMem) {
      if (!Object.prototype.hasOwnProperty.call(_storeMem, k)) continue;
      var e15 = _storeMem[k];
      if (!e15 || typeof e15.at !== 'number' || jetzt - e15.at > CODE_TTL_MS) { delete _storeMem[k]; weg = true; }
    }
    if (weg) storeSave();
    return _storeMem;
  }

  function storeSave() {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(_storeMem || {})); } catch (e) { /* noop */ }
  }

  // ANZEIGE-Fenster (Google-Vorgabe: Rabattpreis mind. 30 Min. zeigen).
  function eintragFrisch(rec) {
    return !!rec && typeof rec.at === 'number' && (Date.now() - rec.at) < ANZEIGE_FENSTER_MS;
  }

  // EINLOESUNG (v5): massgeblich ist der echte Token-Ablauf (exp-Claim,
  // ~60 Min.), nicht das 30-Min.-Anzeigefenster. Alt-Eintraege ohne
  // gespeichertes exp werden bei Bedarf aus dem Token dekodiert.
  function eintragEinloesbar(rec) {
    if (!rec || !rec.token) return false;
    var exp = typeof rec.exp === 'number' ? rec.exp : null;
    if (exp === null) {
      var payload = decodeJwtPayload(rec.token);
      exp = payload && typeof payload.exp === 'number' ? payload.exp : null;
    }
    return exp !== null && exp * 1000 > Date.now();
  }

  function storeHatFrischenEintrag() {
    var s = store();
    for (var k in s) {
      if (Object.prototype.hasOwnProperty.call(s, k) && eintragFrisch(s[k])) return true;
    }
    return false;
  }

  function decodeJwtPayload(token) {
    if (!token) return null;
    var parts = ('' + token).split('.');
    if (parts.length < 2) return null;
    var b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    try { return JSON.parse(window.atob(b64)); } catch (e) { return null; }
  }

  // v18: Variante, deren pv2-Token mit DIESEM Seitenaufruf kam. Race-frei, weil sie schon beim Lesen der URL feststeht.
  var pv2VidDieserSeite = null;
  // pv2 aus der URL lesen und je Variante persistieren (Token + Preise).
  function capturePv2FromUrl() {
    var token;
    try { token = new URLSearchParams(window.location.search).get(URL_PARAM); }
    catch (e) { token = null; }
    if (!token) return;
    var payload = decodeJwtPayload(token);
    if (!payload) return;
    var vid = null;
    if (typeof payload.o === 'string') {
      // 13.09.2026: Offer-ID in beiden Formaten (shopify_DE_<pid>_<vid> und seit 08.09. <pid>-<vid>) -> letzte
      // Zifferngruppe = Varianten-ID. Vorher split('_') -> bei <pid>-<vid> falscher Schluessel.
      var mOffer = payload.o.match(/(\d+)\D*$/);
      vid = mOffer ? mOffer[1] : null;
    }
    if (!vid) return;
    var s = store();
    s[String(vid)] = {
      pp: typeof payload.pp === 'number' ? Math.round(payload.pp * 100) : null,
      p: typeof payload.p === 'number' ? Math.round(payload.p * 100) : null,
      token: token,
      at: Date.now(),
      exp: typeof payload.exp === 'number' ? payload.exp : null,
      code: null
    };
    _storeMem = s;
    storeSave();
    pv2VidDieserSeite = String(vid); // v18: dieses Token kam mit dem Seitenaufruf -> darf ins Korb-Attribut
    if (MODUS === 'code') codeVorabAnlegen(String(vid)); // v16: im Function-Modus entsteht kein Code
  }

  // v9: Code sofort beim Landen anlegen (einmal je Token) und das Cookie
  // setzen. Fehler bleiben still — der Warenkorb-Schritt versucht es erneut.
  function codeVorabAnlegen(vid) {
    var rec = store()[vid];
    if (!rec || !rec.token || rec.code || !eintragEinloesbar(rec)) return;
    fetch(GAD_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ shop: GAD_SHOP, tokens: [rec.token] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; });
    }).then(function (data) {
      if (!data || !data.ok || !data.code) return;
      var s = store();
      if (s[vid]) { s[vid].code = data.code; _storeMem = s; storeSave(); }
      discountCookieSetzen(data.code);
    }).catch(function () { /* noop */ });
  }

  function getEintrag(variantId) {
    var rec = store()[String(variantId)];
    return eintragFrisch(rec) ? rec : null;
  }

  function getGooglePPCents(variantId) {
    var rec = getEintrag(variantId);
    return rec && typeof rec.pp === 'number' ? rec.pp : null;
  }

  function getGooglePCents(variantId) {
    var rec = getEintrag(variantId);
    return rec && typeof rec.p === 'number' ? rec.p : null;
  }

  function getCurrentVariantId() {
    if (currentVariantId) return currentVariantId;
    try {
      var p = new URLSearchParams(window.location.search).get('variant');
      if (p) return p;
    } catch (e) { /* noop */ }
    var input = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"]');
    if (input && input.value) return input.value;
    var data = getVariantData();
    if (data && data.product && data.product.variants && data.product.variants[0]) {
      return data.product.variants[0].id;
    }
    var mv = getMetaVariants();
    if (mv && mv.length === 1) return mv[0].id;
    return null;
  }

  // v18: Variante der gerade betrachteten PRODUKTSEITE — und nur dort.
  // getCurrentVariantId() allein genuegt nicht: seine Rueckfallkette liest auch das erste Schnellkauf-Formular
  // einer Listenseite aus und wuerde dann eine beliebige Karte als 'betrachtet' melden. Auf Listen- und
  // Warenkorbseiten soll es bewusst KEINE betrachtete Variante geben, damit dort aufgeraeumt wird.
  function betrachteteVariante() {
    // Zuerst die Variante, deren pv2-Token mit DIESEM Seitenaufruf kam. Sie steht schon fest, bevor
    // das Theme das Varianten-Ereignis feuert oder das Formular im DOM ist — sonst entscheidet ein
    // Rennen, ob das Attribut bei der Landung schon das Token traegt (19.09. zweimal gemessen: mal ja, mal nein).
    if (pv2VidDieserSeite) return pv2VidDieserSeite;
    try {
      if (String(window.location.pathname || '').indexOf('/products/') < 0) return null;
      var v = getCurrentVariantId();
      return v == null ? null : String(v);
    } catch (e) { return null; }
  }

  // ---- GAD-Einloesung (v3): Warenkorb -> alle Tokens -> EIN Sammel-Code --
  // Zustand des aktuellen Sammel-Codes (eigener localStorage-Schluessel).
  // { code, sig (sortierte Tokenliste), summeCents, at }
  var CART_KEY = 'md_gad_cart';

  function cartState() {
    try {
      var raw = window.localStorage.getItem(CART_KEY);
      return raw ? (JSON.parse(raw) || null) : null;
    } catch (e) { return null; }
  }

  function cartStateSave(st) {
    try {
      if (st) window.localStorage.setItem(CART_KEY, JSON.stringify(st));
      else window.localStorage.removeItem(CART_KEY);
    } catch (e) { /* noop */ }
  }

  // v6: Korb-Marge vom Server holen und als _kx-Attribut ablegen.
  // Fehler bleiben still — der Kauf-Tag faellt dann auf Netto-Umsatz zurueck.
  // v7: Memo ueberspringt den Endpunkt bei unveraendertem Korb-Zustand.
  var KX_MEMO_KEY = 'md_kx_memo';
  var KX_MEMO_TTL_MS = 10 * 60 * 1000; // passend zum Server-Cache
  var margeLaeuft = false;
  var kxZuletzt = null; // v12: letzte entschiedene Werte {kx, kxg} fuer das Kassen-Formular

  // v10: Metafeld-Karte je Variante {kx, kn, at} — aus window.mdzoKx/mdzoKn
  // (dataLayer-Snippet) gesammelt, 24 h gueltig. MWST: KEEP IN SYNC.
  var MWST = 0.19;
  var KX_MAP_KEY = 'md_kx_map';
  var KX_MAP_TTL_MS = 24 * 60 * 60 * 1000;
  var KX_PREIS_PLAUSIBEL_FAKTOR = 3;

  function kxMapLaden() {
    try { return JSON.parse(window.localStorage.getItem(KX_MAP_KEY) || '{}') || {}; }
    catch (e) { return {}; }
  }

  function kxMapSammeln() { kxMapUebernehmen(window.mdzoKx, window.mdzoKn); }

  // v23: auch fuer die Karte aus der Section mdzo-kx
  function kxMapUebernehmen(kx, kn) {
    if (!kx || !kn) return;
    var map = kxMapLaden();
    var now = Date.now();
    var geaendert = false;
    for (var vid in kx) {
      if (!Object.prototype.hasOwnProperty.call(kx, vid)) continue;
      if (typeof kx[vid] !== 'number' || typeof kn[vid] !== 'number') continue;
      map[vid] = { kx: kx[vid], kn: kn[vid], at: now };
      geaendert = true;
    }
    // Alte Eintraege verwerfen (Speicher klein halten).
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k) && (!map[k] || now - map[k].at > KX_MAP_TTL_MS)) {
        delete map[k]; geaendert = true;
      }
    }
    if (geaendert) {
      try { window.localStorage.setItem(KX_MAP_KEY, JSON.stringify(map)); } catch (e) { /* noop */ }
    }
  }

  // Lokale Rechnung wie cart-kx v4; null, wenn eine Position unbekannt ist.
  // v23: nachsichtig=true (nur nach dem Section-Abruf) entscheidet die Randfaelle wie cart-kx v5 statt aufzugeben:
  // Variante ohne Werte zaehlt 0, fehlender/unplausibler Live-Preis -> Tabellenwerte (brutto aus kn, Marge = kx).
  function kxLokal(positionen, nachsichtig) {
    var map = kxMapLaden();
    var now = Date.now();
    var ohne = 0, nachlass = 0;
    for (var i = 0; i < positionen.length; i++) {
      var p = positionen[i];
      var rec = map[String(p.variantId)];
      if (!rec || typeof rec.kx !== 'number' || typeof rec.kn !== 'number' || now - rec.at > KX_MAP_TTL_MS) {
        if (nachsichtig) continue; // unbekannt -> 0 (kein Raten)
        return null;
      }
      var brutto = Math.round(rec.kn * (1 + MWST));
      var preis = p.preisCents;
      if (typeof preis !== 'number' || preis > brutto * KX_PREIS_PLAUSIBEL_FAKTOR ||
          preis * KX_PREIS_PLAUSIBEL_FAKTOR < brutto) {
        if (!nachsichtig) return null; // fehlt/unplausibel -> Rueckfall
        preis = brutto;
      }
      var nettoLive = preis === brutto ? rec.kn : Math.round(preis / (1 + MWST));
      var ek = rec.kn - rec.kx;
      var marge = Math.max(0, nettoLive - ek);
      var nl = 0;
      if (typeof p.googlePreisCents === 'number' && p.googlePreisCents < preis) {
        nl = Math.min(marge, Math.round((preis - p.googlePreisCents) / (1 + MWST)));
      }
      ohne += marge * p.menge;
      nachlass += nl * p.menge;
    }
    return { kx: ohne, kxg: nachlass };
  }

  // v13: gemeinsamer Schreiber, wenn vorhanden; sonst direkt
  function cartSchreiben(body) {
    if (typeof window.mdzoCartWrite === 'function') return window.mdzoCartWrite(body);
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  // v12: Entscheidung merken (auch wenn das Attribut schon stimmt) und Formularfeld setzen
  function kxMerken(kx, kxg) { kxZuletzt = { kx: kx, kxg: kxg }; }
  function feldSetzen(form, name, wert) {
    var inp = form.querySelector('input[name="' + name + '"]');
    if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = name; form.appendChild(inp); }
    inp.value = wert;
  }

  // v14: Gilt der Google-Preis des Eintrags noch fuer die Wertberechnung? Token gueltig ODER Code angelegt und
  // juenger als die Code-Laufzeit (CODE_TTL_MS, siehe oben bei STORE_KEY).
  function gadPreisGueltig(rec) {
    if (!rec || typeof rec.p !== 'number') return false;
    // v16: im Function-Modus gibt es keinen Code — der Google-Preis gilt, solange das Token ins Attribut darf (48 h).
    if (MODUS === 'function') return !!rec.token && typeof rec.at === 'number' && (Date.now() - rec.at) < CODE_TTL_MS;
    if (eintragEinloesbar(rec)) return true;
    return !!rec.code && typeof rec.at === 'number' && (Date.now() - rec.at) < CODE_TTL_MS;
  }

  // v15: Code in die Store-Eintraege der Tokens uebernehmen, die ihn erhalten haben (fuer gadPreisGueltig nach
  // dem Token-Ablauf). Kein Schreiben, wenn nichts neu ist.
  function storeCodeSetzen(tokens, code) {
    if (!code || !tokens || !tokens.length) return;
    var s = store(), geaendert = false;
    for (var k in s) {
      if (!Object.prototype.hasOwnProperty.call(s, k) || !s[k] || !s[k].token) continue;
      if (tokens.indexOf(s[k].token) !== -1 && s[k].code !== code) { s[k].code = code; geaendert = true; }
    }
    if (geaendert) { _storeMem = s; storeSave(); }
  }

  // v19: gesammelt statt sofort. Der Wert fuer die Kasse haengt nicht hieran (siehe kxZuletzt und der
  // submit-Handler weiter unten), deshalb darf der Korb-Write warten. KX_MAX_MS deckelt die Wartezeit,
  // damit er auch bei Dauerklicks landet.
  var KX_SAMMEL_MS = 1500, KX_MAX_MS = 4000;
  var kxTimer = null, kxSeit = 0, kxOffen = null;
  function kxAttributeSetzen(kx, kxg) {
    kxOffen = { _kx: String(kx), _kxg: String(kxg) };
    if (!kxSeit) kxSeit = Date.now();
    if (Date.now() - kxSeit >= KX_MAX_MS) { kxSofortSchreiben(); return; }
    if (kxTimer) clearTimeout(kxTimer);
    kxTimer = setTimeout(kxSofortSchreiben, KX_SAMMEL_MS);
  }
  function kxSofortSchreiben() {
    if (kxTimer) { clearTimeout(kxTimer); kxTimer = null; }
    kxSeit = 0;
    var attrs = kxOffen; kxOffen = null;
    if (!attrs) return;
    cartSchreiben({ attributes: attrs }).catch(function () { /* noop */ });
  }
  // v20: Ausstehendes abgeben, wenn der gemeinsame Schreiber ohnehin gleich sendet. Leert den
  // Zwischenstand und stoppt den Timer — sonst ginge derselbe Wert spaeter ein zweites Mal raus.
  function kxNachliefern() {
    if (!kxOffen) return null;
    if (kxTimer) { clearTimeout(kxTimer); kxTimer = null; }
    kxSeit = 0;
    var attrs = kxOffen; kxOffen = null;
    return attrs;
  }
  try { if (typeof window.mdzoCartNachliefern === 'function') window.mdzoCartNachliefern(kxNachliefern); } catch (e) { /* aelterer Schreiber: dann bleibt es beim eigenen Timer */ }

  // v8: Rabattcode am Cart selbst fuehren. Fremde (Nicht-GAD-)Codes des
  // Kunden bleiben erhalten; GAD-Codes werden durch den aktuellen ersetzt
  // bzw. entfernt (code === null). Kein Aufruf, wenn schon deckungsgleich.
  function istGadCode(code) {
    if (!code) return false;
    for (var i = 0; i < MARKERS.length; i++) {
      if (MARKERS[i] && String(code).toUpperCase().indexOf(MARKERS[i]) === 0) return true;
    }
    return false;
  }

  function cartDiscountSetzen(cart, code) {
    var vorhandene = (cart && cart.discount_codes) || [];
    var soll = [];
    var hatCode = false;
    for (var i = 0; i < vorhandene.length; i++) {
      var c = vorhandene[i] && vorhandene[i].code;
      if (!c) continue;
      if (istGadCode(c)) {
        if (code && String(c).toUpperCase() === String(code).toUpperCase()) { hatCode = true; soll.push(c); }
        continue; // alter GAD-Code faellt weg
      }
      soll.push(c);
    }
    if (code && !hatCode) soll.push(code);
    var unveraendert = soll.length === vorhandene.length && (!code || hatCode);
    if (unveraendert) return;
    cartSchreiben({ discount: soll.join(',') }).catch(function () { /* noop */ });
  }

  function margeAktualisieren(cart) {
    if (margeLaeuft) return;
    var items = (cart && cart.items) || [];
    if (!items.length) return; // leerer Korb: Attribut gegenstandslos
    var s = store();
    var positionen = [];
    var sigTeile = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it || it.variant_id == null) continue;
      var pos = {
        variantId: it.variant_id,
        menge: Math.max(1, parseInt(it.quantity, 10) || 1)
      };
      // v8: Live-Preis der Variante (Cents) — cart-kx v4 rechnet die Marge
      // damit neu, wenn er von der Nachttabelle abweicht (Preisaenderung
      // untertags, Beleg Bestellung 85125462 am 02.09.).
      if (typeof it.price === 'number' && it.price > 0) pos.preisCents = it.price;
      var rec = s[String(it.variant_id)];
      // GAD aktiv: Google-Preis mitgeben, der Server zieht den Nachlass ab.
      // v14: nicht mehr am Token-exp, sondern an der Code-Laufzeit (siehe gadPreisGueltig).
      if (gadPreisGueltig(rec)) {
        pos.googlePreisCents = rec.p;
      }
      positionen.push(pos);
      sigTeile.push(pos.variantId + ':' + pos.menge + ':' + (pos.googlePreisCents || 0) +
        ':' + (pos.preisCents || 0));
    }
    if (!positionen.length) return;

    var sig = sigTeile.sort().join('|');
    var attrs = cart.attributes || {};
    var alt = attrs._kx != null ? String(attrs._kx) : null;
    var altG = attrs._kxg != null ? String(attrs._kxg) : null;
    var memo = null;
    try { memo = JSON.parse(window.localStorage.getItem(KX_MEMO_KEY) || 'null'); } catch (e) { /* noop */ }
    if (memo && memo.sig === sig && typeof memo.kx === 'number' &&
        typeof memo.kxg === 'number' && (Date.now() - memo.at) < KX_MEMO_TTL_MS) {
      // Zustand unveraendert: Endpunkt ueberspringen.
      kxMerken(memo.kx, memo.kxg);
      if (alt !== String(memo.kx) || altG !== String(memo.kxg)) {
        kxAttributeSetzen(memo.kx, memo.kxg);
      }
      return;
    }

    // v10: alles bekannt -> im Browser rechnen, kein Endpunkt.
    var lokal = kxLokal(positionen);
    if (lokal) {
      kxMerken(lokal.kx, lokal.kxg);
      try {
        window.localStorage.setItem(KX_MEMO_KEY,
          JSON.stringify({ sig: sig, kx: lokal.kx, kxg: lokal.kxg, at: Date.now() }));
      } catch (e) { /* noop */ }
      if (alt !== String(lokal.kx) || altG !== String(lokal.kxg)) {
        kxAttributeSetzen(lokal.kx, lokal.kxg);
      }
      return;
    }

    // v23: Karte unvollstaendig -> kx/kn der Korbpositionen vom EIGENEN Shop holen (Section Rendering) und
    // nachsichtig neu rechnen. Scheitert der Abruf, wird nichts geschrieben; das naechste Korb-Ereignis versucht es neu.
    margeLaeuft = true;
    var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(wurzel + '?sections=' + KX_SECTION, { credentials: 'same-origin' }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (data) {
      margeLaeuft = false;
      var html = data && data[KX_SECTION];
      if (typeof html !== 'string') return;
      var knoten = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mdzo-kx]');
      if (!knoten) return;
      var karte = JSON.parse(knoten.textContent); // Fehler -> catch unten
      var kxK = {}, knK = {};
      for (var vid in karte) {
        if (!Object.prototype.hasOwnProperty.call(karte, vid) || !karte[vid]) continue;
        kxK[vid] = karte[vid].kx; knK[vid] = karte[vid].kn;
      }
      kxMapUebernehmen(kxK, knK);
      var erg = kxLokal(positionen, true);
      if (!erg) return;
      var kx = erg.kx, kxg = erg.kxg;
      try {
        window.localStorage.setItem(KX_MEMO_KEY,
          JSON.stringify({ sig: sig, kx: kx, kxg: kxg, at: Date.now() }));
      } catch (e) { /* noop */ }
      kxMerken(kx, kxg);
      if (alt === String(kx) && altG === String(kxg)) return; // unveraendert: kein Cart-Write
      kxAttributeSetzen(kx, kxg);
    }).catch(function () { margeLaeuft = false; });
  }

  // ---- v16: Function-Modus — Tokens der Korb-Varianten als Korb-Attribut --------
  var gadTokensZuletzt = null; // letzter entschiedener Attributwert (fuer das Kassen-Formular)
  // v18: Tokens mit Korb- oder Seitenbezug. Im Korb liegende Varianten zuerst, dann neueste; Cap TOKENS_MAX.
  // Ein Token ohne beide Bezuege bewirkt in der Function ohnehin nichts — es stand nur in der Bestellung und
  // liess sie wie einen Ausfall aussehen. Liefert auch, ob eine Token-Variante wirklich im Korb liegt.
  function tokensFuerKorb(imKorb) {
    var s = store(), liste = [], jetzt = Date.now(), trifftKorb = false;
    var aktuell = betrachteteVariante();
    for (var vid in s) {
      if (!Object.prototype.hasOwnProperty.call(s, vid)) continue;
      var rec = s[vid];
      if (!rec || !rec.token || typeof rec.at !== 'number' || jetzt - rec.at >= CODE_TTL_MS) continue;
      var drin = !!imKorb[vid];
      if (!drin && String(vid) !== aktuell) continue;
      if (drin) trifftKorb = true;
      liste.push({ at: rec.at, token: rec.token, drin: drin });
    }
    liste.sort(function (a, b) { return (a.drin === b.drin) ? (b.at - a.at) : (a.drin ? -1 : 1); });
    var tokens = [];
    for (var i = 0; i < liste.length && i < TOKENS_MAX; i++) tokens.push(liste[i].token);
    return { tokens: tokens, trifftKorb: trifftKorb };
  }
  // v17: Drawer bzw. Warenkorbzeilen neu rendern (gleiche Reihenfolge wie md-vk-bereinigen.js)
  function korbNeuRendern() {
    try {
      var ci = document.querySelector('cart-items');
      var dr = document.querySelector('cart-drawer');
      if (ci && typeof ci.refresh === 'function') ci.refresh();
      else if (dr && typeof dr.refresh === 'function') dr.refresh(true);
    } catch (e) { /* Anzeige bleibt bis zum naechsten Rendern alt */ }
  }
  function tokensAttributAbgleichen(cart, imKorb) {
    var erg = tokensFuerKorb(imKorb), tokens = erg.tokens;
    var soll = tokens.length ? JSON.stringify(tokens) : '';
    var ist = (cart && cart.attributes && cart.attributes[TOKENS_ATTRIBUT]) || '';
    gadTokensZuletzt = soll;
    if (String(ist) !== soll) {
      var attrs = {}; attrs[TOKENS_ATTRIBUT] = soll;
      // v17: lag die Token-Variante beim Write schon im Korb, zeigt die Anzeige noch den alten Preis -> nach dem Write neu rendern
      var nachrendern = erg.trifftKorb || (String(ist) !== '' && ((cart && cart.item_count) || 0) > 0);
      cartSchreiben({ attributes: attrs }).then(function () { if (nachrendern) korbNeuRendern(); }, function () { /* noop */ });
    }
    // Alt-Zustand des Code-Wegs abraeumen: GAD-Code am Korb entfernen (fremde Codes bleiben), Sammel-Code-Zustand und Box weg.
    cartDiscountSetzen(cart, null);
    if (cartState()) cartStateSave(null);
    renderCartBox();
  }

  var einloesungLaeuft = false;
  var einloesungTimer = null;

  // Debounced: mehrere Cart-Events kurz nacheinander loesen EINEN Lauf aus.
  // v11 (05.09.2026): Der Theme-Event liefert den frischen Cart (detail.cart); der wird
  // bis zu 3 s lang statt eines weiteren GET /cart.js benutzt. Der Lauf startet im
  // Leerlauf, damit er nicht mit dem Drawer-Rendern um den Hauptthread konkurriert.
  var eventCart = null, eventCartZeit = 0;
  function sammelEinloesenBald(evt) {
    var c = evt && evt.detail && evt.detail.cart;
    if (c && typeof c.item_count === 'number') { eventCart = c; eventCartZeit = Date.now(); }
    if (einloesungTimer) clearTimeout(einloesungTimer);
    einloesungTimer = setTimeout(function () {
      if (window.requestIdleCallback) { window.requestIdleCallback(sammelEinloesen, { timeout: 1500 }); }
      else { sammelEinloesen(); }
    }, 300);
  }

  function sammelEinloesen() {
    if (einloesungLaeuft) { sammelEinloesenBald(); return; }
    einloesungLaeuft = true;
    var frisch = eventCart && (Date.now() - eventCartZeit) < 3000 ? eventCart : null;
    eventCart = null;
    (frisch ? Promise.resolve(frisch)
            : fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); }))
      .then(function (cart) {
        var imKorb = {};
        var items = (cart && cart.items) || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i] && items[i].variant_id != null) {
            imKorb[String(items[i].variant_id)] =
              Math.max(1, parseInt(items[i].quantity, 10) || 1);
          }
        }
        // v6: Korb-Marge parallel aktualisieren (unabhaengig von GAD).
        margeAktualisieren(cart);
        // v16: Function-Modus — nur das Token-Attribut abgleichen, kein gad-validate, kein Code, kein Cookie.
        if (MODUS === 'function') {
          tokensAttributAbgleichen(cart, imKorb);
          einloesungLaeuft = false;
          return;
        }
        // Alle EINLOESBAREN Tokens (bis Token-exp, v5) der Varianten, die
        // WIRKLICH im Korb liegen — samt ihrer Menge (der Server deckelt sie).
        var tokens = [];
        var mengen = {};
        var eintraege = [];
        var gadVarianteImKorb = false; // Store-Variante liegt (noch) im Korb
        var s = store();
        for (var vid in s) {
          if (!Object.prototype.hasOwnProperty.call(s, vid)) continue;
          if (!imKorb[vid]) continue;
          var rec = s[vid];
          if (!rec || !rec.token) continue;
          gadVarianteImKorb = true;
          if (eintragEinloesbar(rec)) {
            tokens.push(rec.token);
            mengen[vid] = imKorb[vid];
            eintraege.push({ vid: vid, menge: imKorb[vid] });
          }
        }
        var st = cartState();
        // sig enthaelt die Mengen: eine Mengenaenderung ist ein neuer Zustand.
        var sig = tokens.slice().sort().join('|') + '||' +
          eintraege.map(function (e) { return e.vid + ':' + e.menge; }).sort().join('|');
        if (!tokens.length) {
          if (st && st.code && gadVarianteImKorb) {
            // v5: Tokens abgelaufen, Artikel liegt aber noch im Korb — der
            // verdiente Code (48h gueltig) bleibt bestehen. Nur Cookie und
            // Box auffrischen, KEIN Aufraeumen.
            discountCookieSetzen(st.code);
            cartDiscountSetzen(cart, st.code);
            einloesungLaeuft = false;
            renderCartBox();
          } else if (st && st.code) {
            // Google-Artikel wirklich entfernt: Sammel-Code aufraeumen lassen.
            postEinloesung([], st.code, sig, null, cart);
          } else {
            einloesungLaeuft = false;
          }
          return;
        }
        if (st && st.code && st.sig === sig) {
          // Unveraendert: Cookie und Cart-Discount verbindlich nachziehen.
          discountCookieSetzen(st.code);
          cartDiscountSetzen(cart, st.code);
          einloesungLaeuft = false;
          renderCartBox();
          return;
        }
        postEinloesung(tokens, st && st.code ? st.code : null, sig, mengen, cart);
      })
      .catch(function () { einloesungLaeuft = false; });
  }

  function postEinloesung(tokens, vorherigerCode, sig, mengen, cart) {
    var body = { shop: GAD_SHOP, tokens: tokens };
    if (mengen && tokens.length) body.mengen = mengen;
    if (vorherigerCode) body.vorherigerCode = vorherigerCode;
    fetch(GAD_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' }, // einfacher Request, kein Preflight
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; });
    }).then(function (data) {
      einloesungLaeuft = false;
      if (data && data.ok && data.code) {
        // jeStueck: summeCents ist der STUECK-Rabatt (Shopify multipliziert
        // im Checkout selbst) — fuer die Anzeige hier mit der Menge rechnen.
        var anzeige = typeof data.summeCents === 'number' ? data.summeCents : null;
        if (anzeige !== null && data.jeStueck === true && mengen) {
          for (var mv in mengen) {
            if (Object.prototype.hasOwnProperty.call(mengen, mv)) {
              anzeige = anzeige * mengen[mv];
              break;
            }
          }
        }
        cartStateSave({
          code: data.code,
          sig: sig,
          summeCents: anzeige,
          at: Date.now()
        });
        storeCodeSetzen(tokens, data.code); // v15
        discountCookieSetzen(data.code);
        cartDiscountSetzen(cart, data.code); // v8: am Cart selbst
      } else if (data && data.ok) {
        // code:null => kein Rabatt (mehr) noetig; Zustand loeschen und
        // einen ggf. noch am Cart haengenden GAD-Code entfernen.
        cartStateSave(null);
        cartDiscountSetzen(cart, null);
      }
      renderCartBox();
      // Fehler => still: kein Rabatt, alter Zustand bleibt.
    }).catch(function () {
      einloesungLaeuft = false;
    });
  }

  function discountCookieSetzen(code) {
    // Shopify-Mechanik: GET /discount/<code> setzt das Discount-Cookie,
    // der Checkout wendet den Code automatisch an.
    try {
      // redirect:'manual' — das Cookie kommt mit der 302-Antwort, die
      // Startseite dahinter muss nicht geladen werden (v9).
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' })
        .catch(function () { /* noop */ });
    } catch (e) { /* noop */ }
  }

  // ---- Badge / Style ----------------------------------------------------
  var styleInjected = false;
  function injectStyle() {
    if (styleInjected) return;
    styleInjected = true;
    var css =
      '.md-gp-badge{margin:0 0 .4rem;' +
      'background-color:rgba(var(--sale-label-bg-color, 170,17,85,1));' +
      'color:rgba(var(--sale-label-text-color, 255,255,255,1));}' +
      '.md-gp-badge[hidden]{display:none;}' +
      '.md-gp-was{margin-left:.5em;text-decoration:line-through;opacity:.6;font-weight:400;' +
      'font-size:.85em;white-space:nowrap;}' +
      '.md-gp-was::after{content:attr(' + ORIG_ATTR + ');}' +
      '.md-gp-was[hidden]{display:none;}' +
      '.md-gp-hide-was .price__was{display:none !important;}' +
      '.md-gp-hide-sale .product-label--sale:not(.md-gp-badge){display:none !important;}';
    var s = document.createElement('style');
    s.setAttribute('data-md-gp-style', '');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function ensureBadge(priceEl) {
    var parent = priceEl.parentNode;
    if (!parent) return null;
    var badge = parent.querySelector('.md-gp-badge');
    if (!badge) {
      injectStyle();
      badge = document.createElement('span');
      badge.className = 'product-label product-label--sale md-gp-badge';
      badge.textContent = BADGE_TEXT;
      badge.hidden = true;
      parent.insertBefore(badge, priceEl);
    }
    return badge;
  }

  // ---- Kernlogik --------------------------------------------------------
  var OBS_OPTS = { childList: true, characterData: true, subtree: true };
  var currentVariantId = null;
  var observer = null;
  var observedEl = null;
  var stopped = false;
  var winStart = 0;
  var winCount = 0;

  function findPriceEl() {
    return document.querySelector(PRICE_SELECTOR);
  }

  function withPaused(fn) {
    if (observer) observer.disconnect();
    try {
      fn();
    } finally {
      if (observer && observedEl) observer.observe(observedEl, OBS_OPTS);
    }
  }

  function ensureWas(priceEl) {
    var cur = priceEl.querySelector('.price__current');
    if (!cur) return null;
    var was = cur.querySelector('.md-gp-was');
    if (!was) {
      injectStyle();
      var el = document.createElement('span');
      el.className = 'md-gp-was';
      el.hidden = true;
      withPaused(function () { cur.appendChild(el); });
      was = el;
    }
    return was;
  }

  function showWas(priceEl, money) {
    var was = ensureWas(priceEl);
    if (!was) return;
    if (was.getAttribute(ORIG_ATTR) !== money) {
      withPaused(function () { was.setAttribute(ORIG_ATTR, money); });
    }
    if (was.hidden) was.hidden = false;
    // v22 (20.09.2026): nur schreiben, wenn sich etwas aendert — tick() laeuft mehrfach.
    if (!priceEl.classList.contains('md-gp-active')) priceEl.classList.add('md-gp-active');
    var box = priceEl.closest('.product-info__price') || priceEl;
    if (box && box.classList && !box.classList.contains('md-gp-hide-was')) box.classList.add('md-gp-hide-was');
  }

  function hideWas(priceEl) {
    var was = priceEl.querySelector('.md-gp-was');
    if (was && !was.hidden) was.hidden = true;
    // v22 (20.09.2026): nur schreiben, wenn die Klasse ueberhaupt gesetzt ist. Gemessen kam
    // dieser Weg siebenmal je Seitenaufruf, jedes Mal ohne etwas zu aendern.
    if (priceEl.classList.contains('md-gp-active')) priceEl.classList.remove('md-gp-active');
    var box = priceEl.closest('.product-info__price') || priceEl;
    if (box && box.classList && box.classList.contains('md-gp-hide-was')) box.classList.remove('md-gp-hide-was');
  }

  function setBadge(badge, visible) {
    if (badge && badge.hidden === visible) badge.hidden = !visible;
  }

  function setPriceSource(reduced) {
    var klassen = document.documentElement.classList;
    // v21 (20.09.2026): nur schreiben, wenn sich der Zustand wirklich aendert.
    // classList.remove() schreibt das class-Attribut auch dann neu, wenn der Name gar nicht gesetzt
    // ist — und jeder Schreibzugriff an <html> macht den Stil des GANZEN Dokuments ungueltig.
    // Gemessen am 20.09.: sechs solche Schreibzugriffe im 300-ms-Takt, alle ohne inhaltliche
    // Aenderung; sie stammen aus der Wiederholschleife in init(). Die Bedingungen bleiben gleich,
    // es kommt nur die Frage davor, ob ueberhaupt etwas zu tun ist.
    if (reduced) {
      if (!klassen.contains(HTML_CLASS)) klassen.add(HTML_CLASS);
    } else if (!urlHasParam(URL_PARAM)) {
      if (klassen.contains(HTML_CLASS)) klassen.remove(HTML_CLASS);
    }
  }

  function productInfoEl(priceEl) {
    return priceEl.closest('.product-info') || priceEl.closest('.product') || null;
  }

  function hideSaleLabel(priceEl) {
    var pi = productInfoEl(priceEl);
    if (pi && pi.classList && !pi.classList.contains('md-gp-hide-sale')) {
      injectStyle();
      pi.classList.add('md-gp-hide-sale');
    }
  }

  function showSaleLabel(priceEl) {
    var pi = productInfoEl(priceEl);
    // v22 (20.09.2026): Gegenstueck zu hideSaleLabel, das den Waechter schon hatte.
    if (pi && pi.classList && pi.classList.contains('md-gp-hide-sale')) pi.classList.remove('md-gp-hide-sale');
  }

  function unitPriceEl(priceEl) {
    var box = priceEl.closest('.product-info__price') || priceEl.parentNode || priceEl;
    return box ? box.querySelector('.unit-price__price') : null;
  }

  function applyUnitPrice(priceEl, variantId, shownCents) {
    var data = getVariantPriceUnit(variantId);
    if (!data || shownCents == null) return;
    var el = unitPriceEl(priceEl);
    if (!el) return;
    var newCents = null;
    var m = data.measurement;
    if (m && m.quantity_unit && m.reference_unit && m.quantity_unit === m.reference_unit) {
      var qty = parseFloat(m.quantity_value);
      var ref = typeof m.reference_value === 'number' ? m.reference_value : parseFloat(m.reference_value);
      if (qty > 0 && ref > 0) newCents = Math.round(shownCents * ref / qty);
    }
    if (newCents == null) newCents = Math.round(data.unitPrice * shownCents / data.price);
    if (newCents <= 0) return;
    if (!el.hasAttribute('data-md-unit-orig')) {
      el.setAttribute('data-md-unit-orig', el.textContent.trim());
    }
    var money = formatLikeSample(newCents, el.textContent);
    if (el.textContent.trim() !== money) el.textContent = money;
  }

  function netPriceEl(priceEl) {
    var box = priceEl.closest('.product-price') || document;
    return box.querySelector('[data-md-net]');
  }

  function applyNetPrice(priceEl, shownCents) {
    var el = netPriceEl(priceEl);
    if (!el || shownCents == null) return;
    var rate = parseFloat(el.getAttribute('data-md-net-rate'));
    if (!(rate > 0)) return;
    var money = formatLikeSample(Math.round(shownCents / (1 + rate / 100)), el.textContent);
    if (el.textContent.trim() !== money) el.textContent = money;
  }

  function restoreUnitPrice(priceEl) {
    var el = unitPriceEl(priceEl);
    if (!el || !el.hasAttribute('data-md-unit-orig')) return;
    var orig = el.getAttribute('data-md-unit-orig');
    if (orig != null && el.textContent.trim() !== orig) el.textContent = orig;
    el.removeAttribute('data-md-unit-orig');
  }

  // v2-KERN: Google-Preis SELBST in den Preisblock schreiben (frueher App).
  // Nur wenn ein frisches Token fuer die Variante existiert und der
  // Google-Preis unter dem serverseitig gerenderten Shop-Preis liegt.
  function applyGooglePrice(priceEl, vid) {
    var p = getGooglePCents(vid);
    if (p == null || !displayCurrencyIsShopCurrency()) return;
    var shopCents = getVariantShopPriceCents(vid);
    if (shopCents == null || p >= shopCents) return;
    var cur = priceEl.querySelector('.price__current .js-value');
    if (!cur) return;
    var money = formatLikeSample(p, cur.textContent);
    // Nur den reinen Preistext ersetzen; unser .md-gp-was haengt als eigenes
    // Element in .price__current und bleibt unberuehrt.
    var textNode = cur.firstChild;
    if (textNode && textNode.nodeType === 3) {
      if (textNode.nodeValue.trim() !== money) {
        withPaused(function () { textNode.nodeValue = money; });
      }
    } else if (cur.textContent.trim() !== money) {
      withPaused(function () { cur.insertBefore(document.createTextNode(money), cur.firstChild); });
    }
  }

  var scheduled = false;
  function scheduleUpdate() {
    if (stopped || scheduled) return;
    scheduled = true;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    raf(function () {
      scheduled = false;
      update();
    });
  }

  function tripBreaker() {
    var now = Date.now();
    if (now - winStart > 2000) { winStart = now; winCount = 0; }
    winCount += 1;
    if (winCount > 60) {
      stopped = true;
      if (observer) observer.disconnect();
      return true;
    }
    return false;
  }

  function update() {
    if (stopped) return;
    if (tripBreaker()) return;

    var priceEl = findPriceEl();
    if (!priceEl) return;

    var badge = ensureBadge(priceEl);
    var vid = String(getCurrentVariantId());

    // v2: erst den Google-Preis anwenden, dann den Zustand auswerten.
    applyGooglePrice(priceEl, vid);

    var session = isGoogleSession() || urlHasParam(URL_PARAM);
    var cur = priceEl.querySelector('.price__current .js-value');

    if (cur) applyNetPrice(priceEl, parseMoneyCents(cur.textContent));

    if (!session || !cur) {
      hideWas(priceEl);
      restoreUnitPrice(priceEl);
      showSaleLabel(priceEl);
      setBadge(badge, false);
      if (!session) setPriceSource(false);
      return;
    }

    var shown = parseMoneyCents(cur.textContent);

    // Streichpreis-Referenz: bevorzugt Googles "pp", sonst der Shop-Preis.
    // KEIN compare_at-Fallback (siehe Historie: Sale-Artikel wuerden sonst
    // faelschlich die Google-Badge tragen).
    var refCents = getGooglePPCents(vid);
    if (refCents == null && displayCurrencyIsShopCurrency()) {
      refCents = getVariantShopPriceCents(vid);
    }

    var reduced = refCents != null && shown != null && shown < refCents;

    setPriceSource(reduced);

    if (reduced) {
      setBadge(badge, true);
      showWas(priceEl, formatLikeSample(refCents, cur.textContent));
      applyUnitPrice(priceEl, vid, shown);
      hideSaleLabel(priceEl);
    } else {
      hideWas(priceEl);
      restoreUnitPrice(priceEl);
      showSaleLabel(priceEl);
      setBadge(badge, false);
    }
  }

  function observe() {
    var priceEl = findPriceEl();
    if (!priceEl) return;
    var target = priceEl.querySelector('.price__default') || priceEl;
    if (observer && observedEl === target) return;
    if (observer) observer.disconnect();
    observedEl = target;
    observer = new MutationObserver(scheduleUpdate);
    observer.observe(target, OBS_OPTS);
  }

  function tick() {
    observe();
    update();
  }

  // ---- Warenkorb-Transparenz (v3) ---------------------------------------
  // Die Warenkorbseite zeigt Rabattcodes prinzipbedingt nicht (sie wirken
  // erst im Checkout). Diese Box macht den aktiven Sammel-Code sichtbar:
  // EIN Code deckt alle Google-Rabatte des Warenkorbs ab und wird an der
  // Kasse automatisch angewendet.
  function renderCartBox() {
    // v16: im Function-Modus zeigt Shopify den Rabatt selbst an der Zeile — keine eigene Box.
    if (MODUS === 'function') { var weg = document.getElementById('md-gad-cart-box'); if (weg) weg.remove(); return; }
    var container = document.querySelector('cart-items');
    if (!container) return;
    var alt = document.getElementById('md-gad-cart-box');
    var st = cartState();
    if (!st || !st.code) {
      if (alt) alt.remove();
      return;
    }
    var html = '<strong>' + BADGE_TEXT + '</strong><br>' +
      'Dein Rabatt' +
      (typeof st.summeCents === 'number' && st.summeCents > 0
        ? ' (−' + formatLikeSample(st.summeCents, '0,00 €') + ')'
        : '') +
      ' wird an der Kasse automatisch angewendet.';
    if (!alt) {
      injectStyle();
      alt = document.createElement('div');
      alt.id = 'md-gad-cart-box';
      alt.setAttribute('style',
        'margin:12px 0;padding:12px 16px;border-radius:8px;' +
        'background:rgba(var(--sale-label-bg-color, 170,17,85,1));' +
        'color:rgba(var(--sale-label-text-color, 255,255,255,1));font-size:.9em;');
      container.parentNode.insertBefore(alt, container);
    }
    if (alt.innerHTML !== html) alt.innerHTML = html;
  }

  // ---- Init / Trigger ---------------------------------------------------
  function init() {
    kxMapSammeln();
    capturePv2FromUrl();
    tick();
    renderCartBox();
    var tries = 0;
    var iv = setInterval(function () {
      tries += 1;
      tick();
      if (tries >= 6) clearInterval(iv);
    }, 300);

    document.addEventListener('on:variant:change', function (e) {
      var v = e && e.detail && e.detail.variant;
      if (v && v.id != null) currentVariantId = v.id;
      var pe = findPriceEl();
      if (pe) {
        var ue = unitPriceEl(pe);
        if (ue) ue.removeAttribute('data-md-unit-orig');
      }
      tick();
      setTimeout(tick, 150);
      setTimeout(tick, 400);
    });

    // v3: JEDE Warenkorb-Aenderung (auch Entfernen/Reduzieren) stellt den
    // Sammel-Code neu aus — die Edge Function deaktiviert den Vorgaenger.
    document.addEventListener('on:cart:add', sammelEinloesenBald);
    document.addEventListener('on:line-item:change', sammelEinloesenBald);

    // Warenkorbseite: beim Laden abgleichen (deckt Drift ab, z. B. Artikel
    // in anderem Tab entfernt oder Rueckkehr nach Checkout-Abbruch).
    if (document.querySelector('cart-items')) {
      sammelEinloesenBald();
    }

    document.addEventListener('shopify:section:load', tick);

    // v12: _kx/_kxg im Absende-Moment des Kassen-Formulars mitgeben (action /cart,
    // nicht /cart/add|change|update); ohne entschiedenen Wert kein Feld.
    // v19: Beim Verlassen der Seite einen noch gesammelten Marge-Write sofort losschicken.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') kxSofortSchreiben();
    });

    document.addEventListener('submit', function (ev) {
      try {
        var f = ev.target;
        if (!f || f.tagName !== 'FORM' || !kxZuletzt) return;
        var a = f.getAttribute('action') || '';
        if (!/\/cart\/?(\?|$)/.test(a) || /\/cart\/(add|change|update)/.test(a)) return;
        feldSetzen(f, 'attributes[_kx]', String(kxZuletzt.kx));
        feldSetzen(f, 'attributes[_kxg]', String(kxZuletzt.kxg));
        // v16: Tokens ebenfalls im Absende-Moment mitgeben (nur Function-Modus, nur mit entschiedenem Wert)
        if (MODUS === 'function' && gadTokensZuletzt !== null) feldSetzen(f, 'attributes[' + TOKENS_ATTRIBUT + ']', gadTokensZuletzt);
      } catch (e) { /* noop */ }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();